/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * Resolver group is team or a group of teams who are involved in resolving cases of a particular type on passport
 * case management portal. The following are the list of resolver groups with description:-
 * 1) ECCF_CONFIG: <!--TODO: Add document for ECCF_CONFIG-->
 * 2) NOC : Network Operations Center(NOC) is a resolver group which represents team that supports daily operation issues based on different alignments with
 * the carrier manager team in different regions
 *
 * 3) TRANSPORTATION_FINANCE_CONTROLLERSHIP : This team handles financial related disputes between 3P carriers and Amazon.
 *
 * 4) CARRIER_MANAGER: This resolver group represents carrier managers, and is used for granting access to carrier managers
 * to handle specific cases which requires only carrier managers to involve in.
 *
 * 5) CTT_MANIFEST: This resolver group represents tech team who are involved in resolving cases related to manifest issues
 * when front-line team fails to resolve the case and pass it over to tech team.
 **/
export var ResolverGroup;
(function (ResolverGroup) {
    ResolverGroup["ECCF_CONFIG"] = "eccf-config-team";
    ResolverGroup["NOC"] = "noc-team";
    ResolverGroup["TRANSPORTATION_FINANCE_CONTROLLERSHIP"] = "transportation-finance-controllership-team";
    ResolverGroup["CARRIER_MANAGER"] = "carrier-manager";
    ResolverGroup["CTT_MANIFEST"] = "ctt-manifest-team";
})(ResolverGroup || (ResolverGroup = {}));
